export const CHECKOUT_URL =
  'https://deco-emprende.impultienda.ar/checkout/manual-de-esferas-navidenas'

export const BRAND = {
  name: 'Deco Emprende',
  product: 'Manual de Esferas Navideñas',
  subtitle: '+80 Técnicas para Crear Esferas Navideñas',
  logo: 'https://cdn.magicpatterns.com/uploads/3htjHFW9hH2bn6exXMmU3L/LOGO_DECOEMPRENDE.png',
  ebookMockup:
    'https://cdn.magicpatterns.com/uploads/gJ5JedQ8a6WQEWagpXPpn7/MOCK_UP_MANUAL.png',
  heroImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/142cfef5-e988-4fb7-bf60-b21609619f24.jpg',
}

export const TRUST_POINTS = [
  'Sin experiencia previa',
  'Con materiales simples',
  'Acceso inmediato',
]

export const manualIncludes: string[] = [
  'Más de 80 técnicas explicadas paso a paso',
  'Materiales recomendados',
  'Ideas para diferentes estilos',
  'Consejos para evitar errores',
  'Inspiración para crear tus propios diseños',
]

export const offerIncludes: string[] = [
  'Manual completo +80 técnicas',
  '+100 Plantillas Navideñas',
  '+100 Stickers Navideños',
  'Pack de Etiquetas y Packaging',
  'Guía de Emprendimiento Navideño',
]
